// @flow
import type {
  BaseCardsType,
  BlokComponentPropsType,
  BlokComponentType,
  CardSimpleContentType
} from 'components/types';
import renderComponent from 'components/editable/renderComponent';
import { interpolate } from 'react-spring/web.cjs';
import Template from '../Template';
import Carousel from '../Carousel';
import { CardSimpleContent, SimpleContentCardGrid } from './static';
import { AnimatedCardSimpleContent, CARD_DISPLAYS } from './carousel';
import * as componentKeys from '../../../../componentKeys';

const componentMap = {
  [componentKeys.CARD_SIMPLE_CONTENT]: CardSimpleContent
};

const animatedComponentMap = {
  [componentKeys.CARD_SIMPLE_CONTENT]: AnimatedCardSimpleContent
};

const renderComponentCustomPath =
  'components/editable/Cards/SimpleContentCards/index.jsx';
function springsRenderer(
  springs: *[],
  cards: BlokComponentType<CardSimpleContentType>[]
): any {
  return springs.map((styles, index) =>
    renderComponent(
      cards[index],
      {
        key: cards[index]._uid + index,
        customPath: renderComponentCustomPath,
        style: {
          ...styles,
          transform: interpolate(
            [styles.translateX, styles.opacity],
            (translateXVal) => `translate(${translateXVal}px, -50%)`
          )
        },
        onDragStart: (event) => {
          // This prevents the default "drag" effect of links in Safari
          event.preventDefault();
          return false;
        }
      },
      animatedComponentMap
    )
  );
}

const SimpleContentCards = ({
  blok
}: BlokComponentPropsType<{
  ...BaseCardsType,
  cards: BlokComponentType<CardSimpleContentType>[]
}>) => {
  const {
    title,
    sub_title: subTitle,
    description,
    cards,
    call_to_action: callToAction,
    call_to_action_text: callToActionText,
    use_carousel: useCarousel
  } = blok;
  let children;
  if (useCarousel) {
    children = (
      <Carousel
        cards={cards}
        title={title}
        cardDisplays={CARD_DISPLAYS}
        springsRenderer={springsRenderer}
      />
    );
  } else {
    children = (
      <SimpleContentCardGrid>
        {cards.map((card, index) =>
          renderComponent(
            card,
            {
              customPath: renderComponentCustomPath,
              key: card._uid + index,
              totalCards: cards.length
            },
            componentMap
          )
        )}
      </SimpleContentCardGrid>
    );
  }
  return (
    <Template
      callToAction={callToAction}
      callToActionText={callToActionText}
      description={description}
      subTitle={subTitle}
      title={title}
      useCarousel={useCarousel}
    >
      {children}
    </Template>
  );
};

export default SimpleContentCards;
